module.exports = __webpack_public_path__ + "img/logo.e47546b8.png";